<template>
    <div v-if="user" @mouseleave="hideTooltip">
        <a v-on:click="changeFavoriteItem"  :id="getHtmlId('product', productId)" :title="getFavoriteTitle"
           href="javascript:;" class="add-to-wish" v-bind:class="{ added: present }">
            <i  class="demo-icon" v-bind:class="{ 'icon-star': present, 'icon-star-empty': !present}"></i>
        </a>
        <b-tooltip  :show.sync="show"  :target="'product_' + productId" triggers="click"/>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import BTooltip from 'bootstrap-vue/es/components/tooltip/tooltip'

    /**
     * Компонент для отображения и изменения принадлежности товара к избранным.
     *
     * Для работы необходимо передать Id товара к которому относится компонент
     *
     * @vuedoc
     * @module vue:components/FavoriteCatalogItem
     * @exports vue:components/FavoriteCatalogItem
     */
    export default {
        name: "favorite-catalog-item",

        components: {
            'b-tooltip': BTooltip
        },

        props: [
            'product_id'
        ],
        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {string|int} productId - Id товара за который отвечает компонент
         * @property {boolean} show - статус тултипа
         * @property {boolean} present - наличее товара в избранных (используется для определения стилей кнопки)
         */
        data() {
            return {
                productId : this.product_id,
                show: false,
                present: false
            }
        },

        computed: {
            ...mapGetters('favorite', [
                'favoriteItems',
                'favoriteMessages',
            ]),
            ...mapGetters('app', [
                'user',
            ]),

            /**
             *  Вычисляемое свойство которое в зависемости от Id товара определяет его принадлежность
             *  к избранным товарам
             *
             * @method getFavoriteTitle
             */
            getFavoriteItemById: function () {
                if(this.favoriteItems && this.favoriteItems[this.productId] !== 'undefined') {
                    let data = this.favoriteItems[parseInt(this.productId)];
                    this.present = data >= 0;
                    return data;
                }
                return false;
            },

            /**
             *  Вычисляемое свойство которое в зависемости от принадлежности товара к избанным возвражает title тултипа
             *
             * @method getFavoriteTitle
             */

            getFavoriteTitle: function () {
                if(this.favoriteMessages){
                    return this.getFavoriteItemById ? this.favoriteMessages.addedToFavorites : this.favoriteMessages.removedFavorites
                }
            }

        },

        mounted(){
        },

        methods: {
            /**
             *  При нажатии на кнопку добавляет товар в избраннык
             *   устанавливаем this.show = false; так как событие клика тоже меняет значение this.show,
             *   таким образом сохраняя тултип открытым если мышка не покидала область кнопки
             *
             * @method changeFavoriteItem
             */
            changeFavoriteItem(){
                this.show = false;
                if(this.present){
                    this.$store.dispatch('favorite/removeFavoriteItem',this.productId);
                } else {
                    this.$store.dispatch('favorite/addItemToFavorite',this.productId);
                }
            },

            /**
             *  Прячит тултип когда мышка покидает область кнопки.
             *
             * @method hideTooltip
             */

            hideTooltip(){
                this.show = false;
            },
        }
    }


</script>
